import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["style"];
import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import dataQa from '@platform-ui/dataQa';
import { useCollapse } from './hooks';
import s from './CollapseBlock.module.css';
export const CollapseBlock = ({
  delay,
  duration,
  children: childrenProp,
  collapsed: _collapsed = false,
  dataQaData,
  dataQaType: _dataQaType = 'uikit/CollapseBlock',
  minHeight,
  removeCollapsedContent: _removeCollapsedContent = true,
  UNSAFE_className,
  UNSAFE_style,
  onTransitionEnd
}) => {
  // используется в связке с removeCollapsedContent и говорит показывать ли children
  const [withChildren, setWithChildren] = useState(!_collapsed);
  const onExpandStart = useCallback(() => {
    setWithChildren(true);
  }, []);
  const onCollapseEnd = useCallback(() => {
    setWithChildren(false);
  }, []);
  const _useCollapse = useCollapse({
      collapsed: _collapsed,
      delay,
      duration,
      minHeight,
      onCollapseEnd,
      onExpandStart,
      onTransitionEnd
    }),
    {
      blockProps: {
        style
      }
    } = _useCollapse,
    otherBlockProps = _objectWithoutPropertiesLoose(_useCollapse.blockProps, _excluded);
  let children = childrenProp;
  // удаляет содержимое из DOM когда collapse анимация закончилась и до тех пор пока expand анимация не начнется
  if (_removeCollapsedContent && !withChildren) {
    children = null;
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({}, dataQa({
    dataQaType: _dataQaType,
    dataQaData
  }), otherBlockProps, {
    className: cn(s.root, UNSAFE_className),
    style: _extends({}, UNSAFE_style, style)
  }), children);
};